import { render, staticRenderFns } from "./DemandarSobreOferta.vue?vue&type=template&id=2570cf45&scoped=true"
import script from "./DemandarSobreOferta.vue?vue&type=script&lang=ts"
export * from "./DemandarSobreOferta.vue?vue&type=script&lang=ts"
import style0 from "./DemandarSobreOferta.vue?vue&type=style&index=0&id=2570cf45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570cf45",
  null
  
)

export default component.exports